import { gql } from '@apollo/client';

export const RELEASES = gql`
  query Releases($filters: ReleasesFilterInput) {
    releases(filters: $filters) {
      count
      releases {
        id
        releaseNumber
        description
        releaseDate
        projectId
        projectName
        createdAt
      }
    }
  }
`;

export const RELEASE = gql`
  query Release($releaseId: ID!) {
    release(id: $releaseId) {
      id
      releaseNumber
      description
      releaseDate
      projectId
      projectName
      createdAt
    }
  }
`;

export const PROJECT_FOR_RELEASE = gql`
  query ProjectsForRelease($filters: ProjectsFilterInput) {
    projectsForRelease(filters: $filters) {
      count
      projects {
        id
        name
        gchatWebhookUrl
      }
    }
  }
`;

export const PROJECT = gql`
  query project($id: ID!) {
    project(id: $id) {
      id
      name
    }
  }
`;
